export enum WebhookType {
  DROPPED_TRANSACTION = 1,
  MINED_TRANSACTION = 2,
  ADDRESS_ACTIVITY = 4,
  NFT_ACTIVITY = 6,
  NFT_METADATA_UPDATE = 7, // Deprecated for new networks
  GRAPHQL = 8,

  // Not supported
  PENDING_TRANSACTION = 0,
  DELAYED_TRANSACTION = 3,
  GAS_PRICE = 5,
}
